import PropTypes from 'prop-types';
import React from 'react';
import { withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import NoDataComponent from "../../common/noDataComponent";

import './esg.scss';

const POINTER_COLOR = "#444749";

class ESGAverageLine extends React.Component {
    render() {
        const { data } = this.props;
        return (isNullOrUndefined(data) ? <NoDataComponent /> : this.renderContent(data));
    }

    renderContent(data) {
        const marketAvgPosition = this.calculatePosition(data.market_avg);
        const sectorAvgPosition = this.calculatePosition(data.sector_avg);

        const height = 100;
        const center = height / 2;
        const barHeight = 10;
        const pointerHeight = 18;
        const dotRadius = 2;
        const textOffset = 5;
        const fontSize = 7;
        const marketText = this.props.translate(this.props.primaryAttrCountry === "CZ" ? "Common.CzechRepublic" : "Common.SlovakRepublic");
        const sectorText = this.props.translate("Report.ESG.ScoreDetail.Average.Sector", { sectorId: this.props.sectorIdentificator });

        return (
            <svg viewBox={`0 0 240 ${height}`} aria-label="ESG Average Line" preserveAspectRatio="xMidYMid meet">
                <defs>
                    <linearGradient id={this.getGradientId()} x1="0%" y1="0%" x2="100%" y2="0%" gradientUnits="userSpaceOnUse">
                        <stop offset="0%" stopColor="#38b394" stopOpacity="1" />
                        <stop offset="25%" stopColor="#a9c812" stopOpacity="1" />
                        <stop offset="50%" stopColor="#ffd300" stopOpacity="1" />
                        <stop offset="75%" stopColor="#e74310" stopOpacity="1" />
                        <stop offset="100%" stopColor="#c21718" stopOpacity="1" />
                    </linearGradient>
                </defs>
                <text x="5" y={center + 4} fontSize="12" textAnchor="middle" fontWeight="bold">1</text>
                <line x1="20" y1={center} x2="220" y2={center} stroke={`url(#${this.getGradientId()})`} strokeWidth={barHeight} strokeLinecap="round" />
                <text x="235" y={center + 4} fontSize="12" textAnchor="middle" fontWeight="bold">5</text>
                <line x1={marketAvgPosition} y1={center - (barHeight / 2) - pointerHeight} x2={marketAvgPosition} y2={center - (barHeight / 2)} stroke={POINTER_COLOR} strokeWidth="1" />
                <circle cx={marketAvgPosition} cy={center - (barHeight / 2)} r={dotRadius} fill={POINTER_COLOR} />
                <text x={marketAvgPosition} y={center - (barHeight / 2) - pointerHeight - textOffset} textAnchor="middle" fontSize={fontSize}>
                    <tspan x={marketAvgPosition} dy={-fontSize}>{marketText}</tspan>
                    <tspan x={marketAvgPosition} dy={fontSize} fontWeight="bold">{this.formatValue(data.market_avg)}</tspan>
                </text>
                <line x1={sectorAvgPosition} y1={center + (barHeight / 2)} x2={sectorAvgPosition} y2={center + (barHeight / 2) + pointerHeight} stroke={POINTER_COLOR} strokeWidth="1" />
                <circle cx={sectorAvgPosition} cy={center + (barHeight / 2)} r={dotRadius} fill={POINTER_COLOR} />
                <text x={sectorAvgPosition} y={center + (barHeight / 2) + pointerHeight + textOffset + (2 * fontSize)} textAnchor="middle" fontSize={fontSize} >
                    <tspan x={sectorAvgPosition} dy={-fontSize}>{sectorText}</tspan>
                    <tspan x={sectorAvgPosition} dy={fontSize} fontWeight="bold">{this.formatValue(data.sector_avg)}</tspan>
                </text>
            </svg>
        );
    }

    calculatePosition(value) {
        // Assuming the range is 1 to 5, map this to the SVG coordinate system (20 to 220)
        return 20 + ((value - 1) / 4) * 200;
    }

    getGradientId = () => `average-line-grad-${this.props.id}`;

    formatValue = (value) => value.toLocaleString(this.props.activeLanguage.code, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

ESGAverageLine.propTypes = {
    id: PropTypes.string.isRequired,
    data: PropTypes.shape({
        market_avg: PropTypes.number,
        sector_avg: PropTypes.number,
    }).isRequired,
    sectorIdentificator: PropTypes.string,
    primaryAttrCountry: PropTypes.oneOf(["CZ", "SK"])
};

ESGAverageLine.defaultProps = {
    data: null,
    sectorIdentificator: "",
    primaryAttrCountry: "CZ"
};

export default withLocalize(ESGAverageLine);